/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Keylernfoerderungrooms2Inputs */

const de__field_keylernfoerderungrooms2 = /** @type {(inputs: _Field_Keylernfoerderungrooms2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernförderraum-Schlüssel`)
};

/**

* @param {_Field_Keylernfoerderungrooms2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_keylernfoerderungrooms2 = /** @type {((inputs?: _Field_Keylernfoerderungrooms2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Keylernfoerderungrooms2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_keylernfoerderungrooms2(inputs)
});
export { _field_keylernfoerderungrooms2 as "_field_keyLernfoerderungRooms" }